module.exports = __webpack_public_path__ + "static/img/wei-qrcode.f9b1b4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/wei-qrcode.jpg
// module id = ajd0
// module chunks = 1